export const ShopFeedbackStatus = {
  PENDING: 'pending',
  ACTIVE: 'active',
  DELETED: 'deleted',
  MUTED: 'muted',
} as const;

export type ShopFeedbackStatusType = (typeof ShopFeedbackStatus)[keyof typeof ShopFeedbackStatus];

export const ShopFeedbackReplyStatus = {
  PENDING: 'pending',
  ACTIVE: 'active',
  MUTED: 'muted',
  DELETED: 'deleted',
} as const;

export type ShopFeedbackReplyStatusType = (typeof ShopFeedbackReplyStatus)[keyof typeof ShopFeedbackReplyStatus];

export type ShopFeedback = {
  id: number;
  orderId: number;
  automatic: boolean;
  fromUserId: number;
  fromShopId: number;
  toUserId: number;
  toShopId: number;
  rating: number;
  review?: string;
  status: ShopFeedbackStatusType;
  aiUnsafe?: boolean;
  aiUnsafeReason?: string;
  aiCheckedAt?: string;
  unsafe?: boolean;
  unsafeResolvedBy?: string;
  unsafeResolvedAt?: string | Date;
  conversationMessagesAiConfigsId?: number;
  deletedBy?: string;
  deletedAt?: string;
  createdAt: string;
  updatedAt: string;

  reply?: string;
  repliedAt?: string;
  replyStatus?: ShopFeedbackReplyStatusType;
  replyAiUnsafe?: boolean;
  replyAiUnsafeReason?: string;
  replyAiCheckedAt?: string;
  replyUnsafe?: boolean;
  replyUnsafeResolvedBy?: string;
  replyUnsafeResolvedAt?: string | Date;

  history?: ShopFeedback[];
};

export const AutoReviewReason = {
  ORDER_COMPLETED: 'order-completed',
  ORDER_CANCELLED: 'order-cancelled',
} as const;

export type AutoReviewReasonType = (typeof AutoReviewReason)[keyof typeof AutoReviewReason];

// Whether the reviewed party was acting as the seller or the buyer in the
// order that produced this feedback. Supplied by the public feedback endpoint.
export const ReviewedRole = {
  SELLER: 'seller',
  BUYER: 'buyer',
} as const;

export type ReviewedRoleType = (typeof ReviewedRole)[keyof typeof ReviewedRole];

// Public summary of the listing behind a feedback, shown in the item box under the review.
export type ShopFeedbackItem = {
  thumbnail?: string | null;
  categoryTitle?: string | null;
};

export type ShopFeedbackPublic = Pick<
  ShopFeedback,
  'id' | 'rating' | 'review' | 'fromShopId' | 'automatic' | 'createdAt' | 'reply' | 'repliedAt'
> & {
  orderId?: number;
  purchaseId?: number;
  autoReviewReason?: AutoReviewReasonType | null;
  reviewedRole?: ReviewedRoleType | null;
  item?: ShopFeedbackItem | null;
  canReply: boolean;
  canEditReview?: boolean;
  canEditReply?: boolean;
};
